import {
  PROPOSE_RESULT_DATA_DOWNLOAD, PROPOSE_RESULT_DATA_DOWNLOAD_FAILURE, PROPOSE_RESULT_DATA_DOWNLOAD_SUCCESS
} from './mutation-types'

export default {
  state: {
    proposes: []
  },
  getters: {
    csvProposes: state => {
      return state.proposes
    }
  },
  actions: {
    [PROPOSE_RESULT_DATA_DOWNLOAD] ({dispatch, state, commit}, params = null) {
      console.log('PROPOSE_RESULT_DATA_DOWNLOAD')
      var callback = () => {}
      var data = {}
      if (params) {
        data = params.data
        callback = params.callback
      }
      dispatch('apiGet', { url: '/master/proposes/result/data_download', data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_RESULT_DATA_DOWNLOAD_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PROPOSE_RESULT_DATA_DOWNLOAD_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_RESULT_DATA_DOWNLOAD_FAILURE] (state, data) {
      console.log('PROPOSE_RESULT_DATA_DOWNLOAD_FAILURE')
    },
    [PROPOSE_RESULT_DATA_DOWNLOAD_SUCCESS] (state, data) {
      console.log('PROPOSE_RESULT_DATA_DOWNLOAD_SUCCESS')
      state.proposes = data.data.data
      data.callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-result.js